import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../../providers/tools/tools';
import { ModalController } from 'ionic-angular';
// import { allEmojis } from './all-emojies';

@Component({
  selector: 'emoji-picker-launcher',
  templateUrl: 'emoji-picker-launcher.html',
})
export class EmojiPickerLauncherComponent {
  log = debug('app:EmojiPickerLauncherComponent');
  // emojis = allEmojis;

  toggled = false;
  subs = [];
  chosenEmoji = new EventEmitter();
  message;

  //Future endevore : create our own Emoji Picker with our all-emojies list this would allow us to create our own emojis and allow users to submit their own emojis

  constructor(public tools: ToolsProvider, public modalCtrl: ModalController) {}

  ngOnInit() {
    this.tools.logAnalyticsEvent('trackCustom', `lc-view-emojiPickerLauncher`);
    this.subs.push(
      this.tools.on('open-emoji-slider', data => {
        this.message = data;
        this.toggled = true;
      })
    );
  }

  selectEmoji(event) {
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-emojiPickerLauncher-selectEmoji`
    );
    this.log('selected-emoji', event, this.message);
    this.tools.emit('selected-emoji', {
      emoji: event,
      messageId: this.message._id,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/emoji-picker-launcher/emoji-picker-launcher.ts